type Item = {
  id: string;
  name: string;
};

type Move = {
  id: string;
  name: string;
  from: number;
  to: number;
};

type ReorderResult = {
  reorderedCount: number;
  moves: Move[];
};

export function findReorderedItems(
  previous: Item[],
  current: Item[]
): ReorderResult {
  const idToOriginalIndex: Record<string, number> = {};

  previous.forEach((item, index) => {
    idToOriginalIndex[item.id] = index;
  });

  const moves: Move[] = [];

  current.forEach((item, newIndex) => {
    const originalIndex = idToOriginalIndex[item.id];
    if (originalIndex !== newIndex) {
      moves.push({
        id: item.id,
        name: item.name,
        from: originalIndex + 1,
        to: newIndex + 1,
      });
    }
  });

  return {
    reorderedCount: moves.length,
    moves,
  };
}
